import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="mx-auto flex max-w-3xl flex-col items-center gap-4 px-4 py-24 text-center">
      <p className="text-sm font-semibold uppercase tracking-[0.3em] text-danger-400">404</p>
      <h1 className="text-5xl">That page left the stage.</h1>
      <Link to="/" className="btn-primary">
        Back home
      </Link>
    </section>
  );
}
